<script>
import Papa from 'papaparse'
import VueJsonToCsv from 'vue-json-to-csv'
import OrdersComponent from '@/components/OrdersComponent.vue'


import {getDB} from '@/firebase'
import { collection, onSnapshot } from 'firebase/firestore';

export default {
  props: {
    value: String,
  },
  components: {
    OrdersComponent,
  },
  data() {
    return {
      awaitingData: [],
      store: '',
      key: '',
      productsCSV: [],
      tempText: '',
      searchText: '',
      selected: '',
      curBarcode: ''
    }
  },
  methods: {
    async loadShipStation() {

      // const ssRef = getDB().collection('shipstation').doc('BctIj6egZrTtPZvBPIjS')
      // const key = await ssRef.get()
      // if(!key.exists){
      //   console.log('Nothing')
      // }else{
      //   console.log(key.data())
      // }

      const ssRef = collection(getDB(), 'shipstation')
      onSnapshot(ssRef, (snapshot) => {
        this.key = snapshot.docs[0].data().key


      var myHeaders = new Headers()
      myHeaders.append('Host', 'ssapi.shipstation.com')
      myHeaders.append(
        'Authorization',
        this.key
      )

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      }

      fetch(
        'https://ssapi.shipstation.com/orders?orderStatus=awaiting_shipment&sortDir=DESC',
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => (this.awaitingData = JSON.parse(result)))
        .then((result) => (this.awaitingData = this.awaitingData.orders))
        .then((result) => console.log(this.awaitingData))
        .catch((error) => console.log('error', error))

      })

    },
    printData() {
      console.log(this.awaitingData.orders)
    },
    handleFileUploadProd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    },
    searchItems() {

      if(this.tempText.length == 5){//order number
        this.searchText = this.tempText
        this.selected = this.tempText
      }else{//barcode
        this.curBarcode = this.tempText
      }
      this.tempText = ''
    },
  },
  created() {
  },
}
</script>

<template>
  <div class="top-container">
    <h1>ShipStation Orders</h1>
    Enter Product CSV <input v-if="!this.productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" placeholder="Enter Product CSV" /> <br>

    <div v-if="this.awaitingData" class="btn-container">
      <button @click="loadShipStation">Load Data</button>
      <!-- <button @click="printData">Print Data</button> -->
    </div>
  </div>

  <input id="s-btn" v-model="tempText" @keyup.enter="searchItems" placeholder="Scan Order" />
  <div v-for="(order, orderIndex) in this.awaitingData" :key="orderIndex">
    <div v-if="order.orderNumber?.includes(this.searchText)">
      <OrdersComponent :order="order" :store="this.store" :productsCSV="this.productsCSV" :selected="this.selected" :curBarcode="this.curBarcode" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.top-container {
  // text-align: center;
}
button {
  background-color: blueviolet;
  color: white;
  padding: 1em;
  border-radius: 1em;
  border: 2px solid white;
  margin: 1em;
}
button:hover {
  background-color: #892be29a;
  cursor: pointer;
}

input {
  padding: 0.5em;
  border: 4px solid black;
  margin-bottom: 1em;
}
#s-btn{
  // align-self: left;
  // background-color: red;
  margin-left: 0em;
}
.not-in-queue{
  position: fixed;
}
</style>
